import {
  AGENT_TURN_STATUS_TYPES,
  TOOL_CALL_STATUS,
  TOOL_CALL_UNFINISHED_STATUSES
} from '@kentik/ui-shared/kaizen/constants';

export const CONNECT_CARD_STATE = {
  AUTHORIZE: 'authorize',
  CONNECTING: 'connecting',
  CONTINUE: 'continue',
  WAITING_FOR_ASKER: 'waiting_for_asker',
  CONTINUING: 'continuing',
  SKIPPED: 'skipped',
  STOPPED: 'stopped',
  EXPIRED: 'expired',
  DONE: 'done'
};

function waitingState(oauthStatus, isAsker) {
  if (!isAsker) {
    return CONNECT_CARD_STATE.WAITING_FOR_ASKER;
  }

  if (oauthStatus?.connecting) {
    return CONNECT_CARD_STATE.CONNECTING;
  }

  return oauthStatus?.connected ? CONNECT_CARD_STATE.CONTINUE : CONNECT_CARD_STATE.AUTHORIZE;
}

function rowState({ tool, turn, oauthStatus, isAsker }) {
  const turnExpired = turn?.processing_status === AGENT_TURN_STATUS_TYPES.EXPIRED;

  if (
    tool.status === TOOL_CALL_STATUS.APPROVAL_TIMEOUT ||
    (turnExpired && TOOL_CALL_UNFINISHED_STATUSES.includes(tool.status))
  ) {
    return CONNECT_CARD_STATE.EXPIRED;
  }

  switch (tool.status) {
    case TOOL_CALL_STATUS.AWAITING_APPROVAL:
      return waitingState(oauthStatus, isAsker);
    case TOOL_CALL_STATUS.USER_APPROVED:
    case TOOL_CALL_STATUS.EXECUTING:
      return CONNECT_CARD_STATE.CONTINUING;
    case TOOL_CALL_STATUS.USER_REJECTED:
      return CONNECT_CARD_STATE.SKIPPED;
    case TOOL_CALL_STATUS.CANCELLED:
      return CONNECT_CARD_STATE.STOPPED;
    default:
      return CONNECT_CARD_STATE.DONE;
  }
}

export function connectCardState({ tool, turn, oauthStatus, isAsker }) {
  return { state: rowState({ tool, turn, oauthStatus, isAsker }), expiresAt: turn?.wait_expires_at ?? null };
}
